import {CheckCircleIcon} from "@heroicons/react/20/solid";
import {useState} from "react";
import ToggleComponent from "../../generalComponents/toggleComponent";
import {Switch} from "@headlessui/react";


export default function FeaturesList() {
    const [features, setFeatures] = useState([
        "free shipping", "other feature",
        "free shipping", "other feature",
    ]);  // TODO: Pull features from pricing page

    const [isSmsEnabled, setIsSmsEnabled] = useState(false);

    return (
        <div className="space-y-4 rounded"
             style={{
                 border: "1px solid"
             }}>
            {/*<legend className="text-lg font-medium text-gray-900">Features</legend>*/}
            {cellView(isSmsEnabled, setIsSmsEnabled)}
        </div>
    )

    function cellView() {
        return (
            <div
                className="group relative flex rounded-lg border border-gray-300 bg-white p-4 shadow focus:outline-hidden data-checked:border-transparent data-focus:ring-2 data-focus:ring-indigo-500"
            >

                <div className="grid grid-cols-3 w-full items-center text-sm font-medium">
                    {
                        features.map((feature) => (
                            <div className="flex justify-center items-center space-x-1 font-semibold text-gray-900">
                                <CheckCircleIcon aria-hidden="true" className="h-4 w-4 text-green-600"/>
                                <div>
                                    {feature}
                                </div>
                            </div>
                        ))
                    }

                </div>

                <span
                    aria-hidden="true"
                    className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-checked:border-indigo-500 group-data-focus:border"
                />
            </div>
        )
    }
}
